import React from "react";
import { Container, Card, Button, Row, Col, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useLang } from "../contexts/LanguageContext";
import NavbarIndex from "../components/NavbarIndex";
import Footer from "../components/Footer";
import premiumIcon from "../images/pricing_diamont.svg";

export default function Checkout() {
  const { t } = useLang();
  const navigate = useNavigate();
  const { user, tier } = useAuth();

  const handleCheckoutRedirect = (planType) => {
    if (!user) {
      navigate("/register");
      return;
    }

    const monthlyUrl = process.env.REACT_APP_LEMON_MONTHLY_URL;
    const annualUrl = process.env.REACT_APP_LEMON_ANNUAL_URL;
    let baseUrl = planType === "annual" ? annualUrl : monthlyUrl;

    if (!baseUrl) {
      console.error("[Checkout] No checkout URL configured in env.");
      alert("Error: El enlace de compra de Lemon Squeezy no está configurado en las variables de entorno (.env).");
      return;
    }

    // Comprobar si la URL ya contiene parámetros query (?) para usar & o ?
    const separator = baseUrl.includes("?") ? "&" : "?";
    const checkoutUrl = `${baseUrl}${separator}checkout[custom][user_id]=${user.uid}`;
    
    // Redirigir al checkout oficial de Lemon Squeezy
    window.location.href = checkoutUrl;
  };

  return (
    <div className="background" style={{ backgroundSize: "cover", minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <NavbarIndex login_button={false} />
      
      <Container className="flex-grow-1 d-flex align-items-center justify-content-center py-5">
        <Row className="justify-content-center w-100">
          <Col xs={12} lg={10}>
            <Card className="shadow-lg border-0 rounded-4">
              <Card.Body className="p-5">
                <div className="text-center mb-5">
                  <img src={premiumIcon} alt="Premium" className="mb-3" style={{ width: "80px", height: "80px" }} />
                  <h2 className="fw-bold text-dark">{t("PRICING_PLAN_PREMIUM_NAME") || "Readerum Premium"}</h2>
                  <p className="text-muted fs-5">
                    {t("PRICING_PLAN_PREMIUM_DESCRIPTION") || "Lecturas inmersivas, diccionarios ilimitados y transcripciones avanzadas sin límites."}
                  </p>
                </div>

                {tier === "premium" && (
                  <Alert variant="success" className="mb-5 text-center rounded-3 fs-5 py-3">
                    🎉 <strong>¡Ya eres Premium!</strong> Muchas gracias por apoyar a Readerum. Tienes acceso completo a todas las herramientas avanzadas.
                  </Alert>
                )}

                <Row className="g-4 justify-content-center">
                  {/* Plan Mensual */}
                  <Col xs={12} md={5}>
                    <Card className={`h-100 border-2 rounded-4 text-center p-4 transition-card ${tier === "premium" ? "border-light" : "border-light"}`}>
                      <Card.Body className="d-flex flex-column justify-content-between">
                        <div>
                          <h4 className="fw-bold text-secondary mb-3">Plan Mensual</h4>
                          <h2 className="display-4 fw-bold text-dark mb-1">
                            4,99 {t("MONEY_SYMBOL") || "USD"}
                          </h2>
                          <p className="text-muted mb-4">Facturado mes a mes</p>
                          <hr className="my-4" />
                          <ul className="text-start text-secondary mb-4 list-unstyled">
                            <li className="mb-2">✓ Catálogo y audio ilimitados</li>
                            <li className="mb-2">✓ Control de velocidad y autoplay</li>
                            <li className="mb-2">✓ Diccionario de lemas ilimitado</li>
                            <li className="mb-2">✓ Transcripción fonética (show_IPA)</li>
                          </ul>
                        </div>
                        <Button
                          variant="outline-success"
                          className="w-100 py-3 fw-bold rounded-3 btn-lg mt-auto"
                          onClick={() => handleCheckoutRedirect("monthly")}
                          disabled={tier === "premium"}
                        >
                          Elegir Mensual
                        </Button>
                      </Card.Body>
                    </Card>
                  </Col>

                  {/* Plan Anual */}
                  <Col xs={12} md={5}>
                    <Card className={`h-100 border-2 rounded-4 text-center p-4 position-relative ${tier === "premium" ? "border-light" : "border-primary shadow-sm"}`}>
                      {!tier || tier !== "premium" ? (
                        <span className="position-absolute top-0 start-50 translate-middle badge rounded-pill bg-primary px-3 py-2 fs-6">
                          MEJOR VALOR
                        </span>
                      ) : null}
                      <Card.Body className="d-flex flex-column justify-content-between">
                        <div>
                          <h4 className="fw-bold text-primary mb-3">Plan Anual</h4>
                          <h2 className="display-4 fw-bold text-dark mb-1">
                            39,99 {t("MONEY_SYMBOL") || "USD"}
                          </h2>
                          <p className="text-muted mb-4">Equivale a 3,33 {t("MONEY_SYMBOL") || "USD"} / mes</p>
                          <hr className="my-4" />
                          <ul className="text-start text-secondary mb-4 list-unstyled">
                            <li className="mb-2">✓ <strong>Ahorra más del 30%</strong> al año</li>
                            <li className="mb-2">✓ Catálogo y audio ilimitados</li>
                            <li className="mb-2">✓ Control de velocidad y autoplay</li>
                            <li className="mb-2">✓ Diccionario de lemas ilimitado</li>
                            <li className="mb-2">✓ Transcripción fonética (show_IPA)</li>
                          </ul>
                        </div>
                        <Button
                          variant="success"
                          className="w-100 py-3 fw-bold rounded-3 btn-lg mt-auto shadow-sm"
                          onClick={() => handleCheckoutRedirect("annual")}
                          disabled={tier === "premium"}
                        >
                          Elegir Anual (Ahorro)
                        </Button>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                <div className="text-center mt-5">
                  <Button variant="link" className="text-decoration-none text-muted" onClick={() => navigate("/home")}>
                    Volver al catálogo
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      <Footer />
    </div>
  );
}
